"use client";

import { useEffect, useState } from "react";
import FCMInit from "@/app/components/fcm-init";
import { AnnouncementDialog } from "@/app/components/popup/announcement";
import { ANNOUNCEMENT_TRIGGER_SCREENS } from "@/app/utils/constants";
import { FCM } from "@/app/interface/homepage";

/**
 * Homepage-only FCM foreground listener + announcement dialog.
 * Token registration stays in the root FcmTokenProvider.
 */
const HomeFcmAnnouncement = () => {
    const [message, setMessage] = useState<FCM>();
    const [renderAnnouncement, setRenderAnnouncement] = useState(false);

    useEffect(() => {
        if (message) {
            setRenderAnnouncement(true);
        }
    }, [message]);

    return (
        <>
            <FCMInit setMessage={setMessage} />
            {message?.triggerScreen === ANNOUNCEMENT_TRIGGER_SCREENS.HomeScreen && (
                <AnnouncementDialog
                    renderAnnouncement={renderAnnouncement}
                    setrenderAnnouncement={setRenderAnnouncement}
                    data={message}
                />
            )}
        </>
    );
};

export default HomeFcmAnnouncement;
